// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"152c486c","204":"b8282581","397":"7eb70a20","401":"5d12a0be","763":"152c486c"}[chunkId] + ".chunk.css";
};